import { Trans } from 'react-i18next';

import { Anchor, Body2 } from '@myphx-engineering/phx-design-system';
import { useDisclosure } from '@myphx-engineering/phx-design-system/hooks';

import { useProgramTerms } from '../../../../../hooks/use-program-terms';
import { isIncentiveOffer } from '../../../../../util/offers/is-incentive-offer';
import { IncentiveTermsModal } from '../../common/IncentiveTermsModal';
import type { PricingCardElementProps } from '../../common/shared';

export const SelfPayIncentivePricingTerms = ({
    hasIncentiveProgram,
    medication,
    offer,
}: Omit<PricingCardElementProps, 'patientPay' | 'priceType' | 'savings'>) => {
    const [showTermsModal, { close: closeTermsModal, open: openTermsModal }] =
        useDisclosure(false);

    const terms = useProgramTerms(medication, 'self-pay');

    if (!hasIncentiveProgram || (!!offer && !isIncentiveOffer(offer))) {
        return null;
    }

    const termsUrl = terms?.incentiveProgram?.termsUrl;

    return (
        <>
            <Body2>
                <Trans
                    i18nKey="fill.pricing.seeTerms"
                    components={{
                        1: termsUrl ? (
                            <Anchor href={termsUrl} target="_blank" />
                        ) : (
                            <Anchor onClick={openTermsModal} />
                        ),
                    }}
                />
            </Body2>
            <IncentiveTermsModal
                isOpen={showTermsModal}
                onClose={closeTermsModal}
                programName={terms!.incentiveProgram!.name}
                termsText={terms!.incentiveProgram!.terms ?? ''}
            />
        </>
    );
};
